var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3675_134209)",
    filter: "url(#filter0_d_3675_134209)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9681 8.37971C11.3979 7.94994 11.9808 7.7085 12.5885 7.7085C13.1963 7.7085 13.7792 7.94994 14.209 8.37971C14.6388 8.80948 14.8802 9.39237 14.8802 10.0002C14.8802 10.608 14.6388 11.1908 14.209 11.6206C13.7792 12.0504 13.1963 12.2918 12.5885 12.2918C11.9808 12.2918 11.3979 12.0504 10.9681 11.6206C10.5383 11.1908 10.2969 10.608 10.2969 10.0002C10.2969 9.39237 10.5383 8.80948 10.9681 8.37971ZM12.5885 8.9585C12.3123 8.9585 12.0473 9.06824 11.852 9.26359C11.6566 9.45894 11.5469 9.7239 11.5469 10.0002C11.5469 10.2764 11.6566 10.5414 11.852 10.7367C12.0473 10.9321 12.3123 11.0418 12.5885 11.0418C12.8648 11.0418 13.1298 10.9321 13.3251 10.7367C13.5205 10.5414 13.6302 10.2764 13.6302 10.0002C13.6302 9.7239 13.5205 9.45894 13.3251 9.26359C13.1298 9.06824 12.8648 8.9585 12.5885 8.9585Z",
    fill: "#B5B6C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82172 10C7.7076 12.9866 9.965 14.375 12.5879 14.375C15.2108 14.375 17.4682 12.9866 19.3541 10C17.4682 7.01337 15.2108 5.625 12.5879 5.625C9.965 5.625 7.7076 7.01337 5.82172 10ZM4.55196 9.67844C6.62676 6.22044 9.30317 4.375 12.5879 4.375C15.8726 4.375 18.549 6.22044 20.6238 9.67844C20.7426 9.87637 20.7426 10.1236 20.6238 10.3216C18.549 13.7796 15.8726 15.625 12.5879 15.625C9.30317 15.625 6.62676 13.7796 4.55196 10.3216C4.4332 10.1236 4.4332 9.87637 4.55196 9.67844Z",
    fill: "#B5B6C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3675_134209",
    x: -1.41211,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3675_134209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3675_134209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3675_134209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.58789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.caa9747c1a1f96347187bc67e1ca6bd9.svg";
export { ForwardRef as ReactComponent };